import { useNotification } from '@shared/plugin/prime-vue/useNotification';
import { type MaybeRefOrGetter, toValue } from 'vue';

export default function useUploadFieldBase(maxSize: MaybeRefOrGetter<number>) {
  const notification = useNotification();

  function checkSize(file: File) {
    const _maxSize = toValue(maxSize);
    const maxSizeInMB = Math.round((_maxSize / (1024 * 1024)) * 10) / 10;

    if (file.size > _maxSize) {
      notification.error(
        `Bestandsgrootte van ${file.name} is te groot. Maximaal toegestane grootte is ${maxSizeInMB} MB.`,
      );
      return false;
    }

    return true;
  }

  return {
    checkSize,
  };
}
